import React from 'react';
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { HelmetProvider } from 'react-helmet-async';
import { AppSettingsProvider } from "./contexts/AppSettingsContext"


// Pages
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
      <HelmetProvider>
        <AppSettingsProvider>
          <App />
        </AppSettingsProvider>
        </HelmetProvider>
      </BrowserRouter>
  </React.StrictMode>
);


 